// API Configuration
// This file centralizes all API endpoint configurations

// Get API base URL from environment variables
export const API_BASE_URL = process.env.REACT_APP_API_URL;

// API endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}/api/login`,
  
  // Admin endpoints
  ADMIN_TEACHERS: `${API_BASE_URL}/api/admin/teachers`,
  ADMIN_STUDENTS: `${API_BASE_URL}/api/admin/students`,
  ADMIN_EXAMS: `${API_BASE_URL}/api/admin/exams`,
  ADMIN_RESULTS: `${API_BASE_URL}/api/admin/results`,
  ADMIN_DELETE_TEACHER: `${API_BASE_URL}/api/admin/delete-teacher`,
  ADMIN_DELETE_STUDENT: `${API_BASE_URL}/api/admin/delete-student`,
  
  // Teacher endpoints
  TEACHER_STUDENTS: `${API_BASE_URL}/api/teacher/students`,
  TEACHER_EXAMS: `${API_BASE_URL}/api/teacher/exams`,
  TEACHER_RESULTS: `${API_BASE_URL}/api/teacher/results`,
  TEACHER_PROCTORING_LOGS: `${API_BASE_URL}/api/teacher/proctoring-logs`,
  
  // Student endpoints
  STUDENT_UPCOMING_EXAMS: `${API_BASE_URL}/api/student/upcoming-exams`,
  STUDENT_COMPLETED_EXAMS: `${API_BASE_URL}/api/student/completed-exams`,
  STUDENT_RESULTS: `${API_BASE_URL}/api/student/results`,
  
  // Exam endpoints
  EXAM_DETAILS: (examId) => `${API_BASE_URL}/api/exam/${examId}`,
  EXAM_SUBMIT: `${API_BASE_URL}/api/exam/submit`,
  EXAM_SUBMISSIONS: `${API_BASE_URL}/api/exam/submissions`,
  EXAM_QUESTIONS: (examId) => `${API_BASE_URL}/api/exam/${examId}/questions`,
  
  // Subject endpoints
  SUBJECTS: `${API_BASE_URL}/api/subjects`,
  
  // Health check
  HEALTH: `${API_BASE_URL}/health`,
};

// Default headers for API requests
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

// Helper function to create authorization header
export const createAuthHeader = (user) => {
  if (!user) return {};
  
  return {
    'Authorization': `Bearer ${btoa(JSON.stringify(user))}`
  };
};

// Helper function to make API requests with proper headers
export const apiRequest = async (url, options = {}) => {
  const finalOptions = {
    ...options,
    headers: {
      ...DEFAULT_HEADERS,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, finalOptions);
    return response;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// Helper function to make authenticated API requests
export const authenticatedApiRequest = async (url, user, options = {}) => {
  const authHeaders = createAuthHeader(user);
  
  return apiRequest(url, {
    ...options,
    headers: {
      ...options.headers,
      ...authHeaders,
    },
  });
};
